import React, {useEffect, useState} from "react";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_STRENGTH_ANALYSIS_DATA_API} from "../../constants/api_constants";
import {getImage} from "../../constants/constants";
import WinningBarGraph from "./WinningBarGraph";
import BarGraph from "./BarGraph";

export const basketballMaxValue = [
  {key: "필드골 횟수", maxValue: 120},
  {key: "필드골 성공횟수", maxValue: 70},
  {key: "필드골 %", maxValue: 100},
  {key: "2pt 필드골 횟수", maxValue: 76},
  {key: "2pt 필드골 성공횟수", maxValue: 62},
  {key: "2pt 필드골 %", maxValue: 100},
  {key: "3pt 필드골 횟수", maxValue: 63},
  {key: "3pt 필드골 성공횟수", maxValue: 37},
  {key: "3pt 필드골 %", maxValue: 100},
  {key: "자유투 횟수", maxValue: 39},
  {key: "자유투 성공횟수", maxValue: 34},
  {key: "총 리바운드", maxValue: 60},
  {key: "공격 리바운드", maxValue: 40},
  {key: "수비 리바운드", maxValue: 45},
  {key: "파울", maxValue: 30},
  // {key: "테크니컬 파울", maxValue: 70}, // FIXME : maxValue 정보 없음 -> 과장님 물어보고 수정해야됨
  {key: "블락", maxValue: 15},
  {key: "어시스트", maxValue: 35},
  {key: "스틸", maxValue: 20},
  {key: "턴오버", maxValue: 30},
]

const StrengthAnalysisComponent = ({dataId, analysisType}) => {
  // 상단 최근 결과
  const [homeTeamRecordText, setHomeTeamRecordText] = useState("");
  const [awayTeamRecordText, setAwayTeamRecordText] = useState("");
  // 하단 막대 그래프
  const [winningData, setWinningData] = useState([]);
  const [attackData, setAttackData] = useState([]);
  const [defenseData, setDefenseData] = useState([]);

  const [buttunSelectData, setButtunSelectData] = useState(1); // 1: 전체, 2.홈/원정, 3.원정경기 TODO: 버튼 데이터 차후 수정
  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);

  useEffect(() => {
    getStrengthAnalysisData();
  }, []);

  const getStrengthAnalysisData = () => {
    // 전력 분석
    getFetcherAnalysis().get(GET_STRENGTH_ANALYSIS_DATA_API + `?dataId=${dataId}&recodeType=${buttunSelectData}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            const _data = data[0].powerData[0];
            if (_data.length === 0) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            setHomeTeamRecordText(_data.homeTeamRecordText);
            setAwayTeamRecordText(_data.awayTeamRecordText);
            setWinningData(_data.winningRate[0]);
            setAttackData(_data.attack);
            setDefenseData(_data.defense);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => console.log(err));
  }

  const getBarGraphConfigByName = (name) => {
    // 배열에 값이 지정되어있는 항목은 maxValue 반환하고 % 항목은 isPercent=true 반환
    const trimmedName = name.trim();
    const isInclude = basketballMaxValue.find(item => item.key === trimmedName);
    const isPercent = trimmedName.includes('%');

    return {
      maxValue: isInclude ? isInclude.maxValue : -1,
      isPercentValue: isPercent
    };
  };

  const setResultColor = (text) => {
    // 승무패에 따라 텍스트 색상 지정
    if (!text) return null;

    return text.split(/(\[승\]|\[패\]|\[무\])/).map((word, index) => {
      let colorClass = "";
      if (word === "[승]") {
        colorClass = "text-red-600"; // 빨간색
      } else if (word === "[패]") {
        colorClass = "text-blue-600"; // 파란색
      } else if (word === "[무]") {
        colorClass = "text-black"; // 검정색
      }

      return (
          <span key={index} className={colorClass}>
            {word}
          </span>
      );
    });
  };

  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }
  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    )
  }

  let homeTeamRecords = homeTeamRecordText.split('|');
  let awayTeamRecords = awayTeamRecordText.split('|')

  function getRecordText(teamRecords) {
    if (teamRecords.length === 2) {
      return teamRecords[1];
    }

    let text = "";
    let temp;
    for (let index = 1; index < teamRecords.length; index++) {
      temp = teamRecords[index].trim();
      if (temp.length == 0)
        continue;
      if (!temp.startsWith('[') && !temp.endsWith(']')) {
        temp = '[' + temp + ']';
      }
      text += temp;
    }
    return text;
  }


  return (
      <div className="pl-2 h-full overflow-y-scroll">
        <span className="text-xl font-bold">전력분석 통계</span>
        {analysisType === "report" && <span className="text-md font-bold"> [시즌 전체 평균]</span>}

        {/*홈팀 전적 통계 */}
        <div className="flex flex-row items-center justify-start my-3 w-full">
          <span className="text-white bg-red-600 mr-2 px-2 py-1 rounded-full w-1/4 max-w-1/4 text-center">
            {homeTeamRecords[0]}
          </span>
          <div className="border border-black py-1 w-3/4 text-center rounded-full shadow-md">
            {setResultColor(getRecordText(homeTeamRecords))}
          </div>
        </div>

        {/*원정팀 전적 통계 */}
        <div className="flex flex-row items-center justify-start mb-3 w-full">
          <span className="text-white bg-blue-600 mr-2 px-2 py-1 rounded-full w-1/4 max-w-1/4 text-center">
            {awayTeamRecords[0]}
          </span>
          <div className="border border-black py-1 w-3/4 text-center rounded-full shadow-md">
            {setResultColor(getRecordText(awayTeamRecords))}
          </div>
        </div>

        <div className="my-5">
          {/* <-- 홈 원정 승률 --> */}
          <WinningBarGraph data={winningData}/>

          {/* <-- 공격 데이터 --> */}
          <div className="flex flex-col border border-black">
            <h2 className="flex justify-center items-center bg-gray-900 text-white mb-2">공격</h2>
            {attackData.map((item, index) => {
              const {maxValue, isPercentValue} = getBarGraphConfigByName(item.name);

              return (
                  <BarGraph item={item}
                            key={index}
                            isPercentValue={isPercentValue}
                            maxValue={maxValue}
                  />
              );
            })}
          </div>

          {/*/!* <-- 수비 데이터 --> *!/*/}
          <div className="flex flex-col border border-black mt-3">
            <h2 className="flex justify-center items-center bg-gray-900 text-white mb-2">수비</h2>
            {defenseData.map((item, index) => {
                  const {maxValue, isPercentValue} = getBarGraphConfigByName(item.name);

                  return (
                      <BarGraph item={item}
                                key={index}
                                isPercentValue={isPercentValue}
                                maxValue={maxValue}
                      />
                  );
                }
            )}
          </div>
        </div>
      </div>
  )
}
export default StrengthAnalysisComponent;

